import React from 'react';
import Typography from '@material-ui/core/Typography';
import Link from '@material-ui/core/Link';
import { makeStyles } from "@material-ui/core/styles";

const styles = (theme) => ({
  footb: {
    display: "flex",
    justifyContent: "space-between"
  }
});

const useStyles = makeStyles(styles);


function Footer() {
   const classes = useStyles();
  return (
    <div className={classes.footb}>
    

    <Typography variant="body2" color="textSecondary" align="center">
      {''}
      <Link color="inherit" href="https://github.com/NovelCOVID/">
        NovelCOVID
      </Link>
    
    </Typography>

    <Typography variant="body2" color="textSecondary" align="center">
      {''}
      <Link color="inherit" href="https://ebenladipo.com">
        Olaide-EO
      </Link>{' '}
      {new Date().getFullYear()}
      {'.'}
    </Typography>
    </div>
  );
}

export default Footer;